import palette from '../palette';

export default {
    root: {
        backgroundColor: palette.lightBlue.light,
        color: palette.headersColor,
        fontSize: '14px',
    },
};
